"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterForestPolygons = void 0;
const turf_1 = require("@turf/turf");
/**
 * Returns only the features that have classLabels that suggest they are forest/trees
 * If the polygons do not contain `class_labels` (eg generated by an old AI), an error
 * is thrown
 *
 * @param features The features to filter
 * @returns A feature collection that only contains forest polygons
 */
function filterForestPolygons(features) {
    return (0, turf_1.featureCollection)(features.features.filter((feature) => {
        if (feature.properties.class_labels) {
            return feature.properties.class_labels.some((label) => label === 'FOREST' || label === 'SETTLEMENTS');
        }
        throw new Error('AI Properties lacking class_labels');
    }));
}
exports.filterForestPolygons = filterForestPolygons;
